import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import classNames from "classnames";
import { UiLogoutIcon } from "@jti/brand-icons/ui-logout";
import { liveChat } from "@jti/fe-clients";
import { useTranslations } from "../../providers/useTranslations";
import { Button } from "../Button";
import styles from "./SignOut.module.scss";
export const SignOut = ({ logout, className }) => {
    const { __ } = useTranslations();
    const [disableLogout, setDisableLogout] = useState(false);
    const logoutHandler = useCallback(() => {
        setDisableLogout(true);
        logout().finally(() => {
            setDisableLogout(false);
            liveChat.onLogout();
        });
    }, [logout]);
    return (_jsxs(Button, { color: "secondary", onClick: logoutHandler, disabled: disableLogout, "data-testid": "signOutButton", className: classNames(styles.button, className), children: [_jsx(UiLogoutIcon, {}), " ", _jsx("span", { children: __("libs.ui.sign_out") })] }));
};
//# sourceMappingURL=SignOut.js.map